import { Component } from 'react';
import { API_ENDPOINT } from '../../../constants';
import ListBuilder from '../../../components/listBuilder';
import Isvg from 'react-inlinesvg';
import deleteIcon from '../../../assets/svg/garbage.svg';
import editIcon from '../../../assets/svg/edit.svg';
import addIcon from '../../../assets/svg/add-icon.svg';
import FormBuilder from '../../../components/forms/modalFormBuilder';
import { required } from '../../../components/forms/validation';
import DeleteModal from '../../../components/deleteModal';
import {
	updateParamsHelper,
	getParamsFromURL,
	parseJSON,
} from '../../../helpers/custom.helper';
import PreviewModal from '../../../components/previewModal';
import infoIcon from "../../../assets/svg/link-new-tab.svg";
import ErrorModal from '../../../components/errorModal';
import AlertIcon from '../../../assets/svg/alert-healt-flags.svg'


export default class HealthFlagsTab extends Component {
	constructor(props) {
		super(props);
		this.state = {
			TYPES_OPTIONS: [
				{ label: 'Allergy'.translate(this.props.lang), value: 'allergy' },
				{
					label: 'Intolerance'.translate(this.props.lang),
					value: 'intolerance',
				},
				{ label: 'Infection'.translate(this.props.lang), value: 'infection' },
				{ label: 'Warning'.translate(this.props.lang), value: 'warning' },
				{ label: 'Disease'.translate(this.props.lang), value: 'disease' },
				{ label: 'Other'.translate(this.props.lang), value: 'other' },
			],
			SEVERITY_OPTIONS: [
				{ label: 'Moderate'.translate(this.props.lang), value: 'moderate' },
				{ label: 'Severe'.translate(this.props.lang), value: 'severe' },
				{
					label: 'Life-threatening'.translate(this.props.lang),
					value: 'life-threatening',
				},
			],
			form: false,
			preview: false,
			total: 0,
			params: {
				entries: 10,
				page: 0,
				sortField: 'tsCreatedAt',
				sortType: -1,
				filter: '',
			},
			loading: true,
			healthFlags: [],
			error: null,
			modified: 'Not modified'.translate(this.props.lang),
			deleteHealthFlag: null,
			isConsentActive: false,
			clinicUserPermissions: null
		};
	}

	get = async () => {
		this.setState({
			loading: true,
			healthFlags: [],
			modified: 'Not modified'.translate(this.props.lang),
		});

		try {
			// fetch(API_ENDPOINT + `/users/users/patient/journal-system/has-consent/${this.props.patientId}/${this.props._groupId}`, {
			// 	method: 'GET',
			// 	headers: {
			// 		'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
			// 		'content-type': 'application/json'
			// 	},
			// }).then(res => res.json()).then((result) => {
			// 	if (result.success) {
			// 		this.setState({
			// 			isConsentActive: true
			// 		})
			// 	} else {
			// 		this.setState({
			// 			isConsentActive: false
			// 		})
			// 	}
			// })

			const response = await fetch(
				`${API_ENDPOINT}/users/users/patient/patientHealthFlags/get`,
				{
					method: 'POST',
					headers: {
						'Content-Type': 'application/json',
						Authorization: `Bearer ${localStorage.getItem('authToken')}`,
					},
					body: JSON.stringify({
						groupAlias: localStorage.getItem('groupAlias'),
						groupId: this.props._groupId || null,
						patientId: this.props.patientId,
						total: this.state.total,
						entries: this.state.params?.entries,
						page: this.state.params?.page,
						sortField: this.state.params?.sortField,
						sortType: this.state.params?.sortType,
						filter: this.state.params?.filter,
						isConsentGrantedAndActive: this.props.isConsentGrantedAndActive
					}),
				}
			);

			const data = await response.json();

			if (data.items) {
				const newState = {
					loading: false,
					healthFlags: data.items,
					total: data.total,
				};

				if (data.tsModified) {
					const modified = this.props.getStringDateTs?.(
						data.tsModified,
						this.props.dateFormat
					);
					if (modified) newState.modified = modified?.translate(this.props.lang);
				}

				this.setState(newState);
			} else {
				const errState = {
					loading: false,
					modified: 'Not modified'.translate(this.props.lang),
				};

				if (data.error) {
					errState.error = data.error;
				}

				this.setState(errState);
			}
		} catch (err) {
			this.setState({
				loading: false,
				error: err?.message || 'Error fetching health flags',
			});
		}
	};

	getClinicUserData = async () => {
		try {
			const response = await fetch(`${API_ENDPOINT}/journal-curoflow/clinic-user/get-permission`, {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
					Authorization: `Bearer ${localStorage.getItem('authToken')}`,
				},
				body: JSON.stringify({ groupId: this.props._groupId }),
			});

			const result = await response.json();

			this.setState({ clinicUserPermissions: result?.data?.permissions });
		} catch (err) {
			console.log('Err get clinic user data', err);
		}

	}

	componentDidMount() {
		this.getClinicUserData();

		const urlParams = getParamsFromURL();

		const newParams = {
			...this.state.params,
			entries: urlParams.entries,
			filter: urlParams.filter,
		};

		this.setState({ params: newParams }, () => {
			if (this.props.healthFlags) {
				this.setState({
					loading: false,
					healthFlags: this.props.healthFlags,
				});
			} else {
				this.get();
			}
		});
	}

	componentDidUpdate(prevProps) {
		if (
			prevProps.patientId !== this.props.patientId ||
			prevProps._groupId !== this.props._groupId ||
			prevProps.view !== this.props.view
		) {
			this.setState({
				loading: true,
				healthFlags: [],
				modified: 'Not modified'.translate(this.props.lang),
			});

			this.get();
		}

		if (this.props.isConsentGrantedAndActive !== prevProps.isConsentGrantedAndActive) {
			this.get();
		}
	}

	// always copy - paste these updateSort, updateParams, updateMultipleParams
	updateSort = (field, type) => {
		updateParamsHelper(this, { sortField: field, sortType: type });
	};

	updateParams = (name, value, restart = false) => {
		updateParamsHelper(this, { [name]: value }, restart);
	};

	updateMultipleParams = (fields, restart = false) => {
		updateParamsHelper(this, fields, restart);
	};

	insertOrUpdate = (data) => {
		const id = data._id ?? 'new';

		const healthFlag = {
			type: data.type,
			substance: data.substance,
			reaction: data.reaction,
			severity: data.severity,
			notes: data.notes,
		};

		const body = {
			groupId: this.props._groupId,
			patientId: this.props.patientId,
			healthFlag,
		};

		fetch(API_ENDPOINT + '/users/users/patient/patientHealthFlags/' + id, {
			method: id === 'new' ? 'POST' : 'PUT',
			headers: {
				Authorization:
					typeof localStorage !== 'undefined'
						? `Bearer ${localStorage.getItem('authToken')}`
						: null,
				'content-type': 'application/json',
			},
			body: JSON.stringify(body),
		})
			.then(parseJSON)
			.then(({ result, status }) => {
				if (result.error) {
					this.setState({ error: result.error });
				} else {
					this.get();
					this.setState({
						form: false,
					});
				}
			});
	};

	delete = (data) => {
		this.setState(
			{
				loading: true,
			},
			() => {
				fetch(
					API_ENDPOINT + '/users/users/patient/patientHealthFlags/' + data._id,
					{
						method: 'DELETE',
						headers: {
							Authorization:
								typeof localStorage !== 'undefined'
									? `Bearer ${localStorage.getItem('authToken')}`
									: null,
							'content-type': 'application/json',
						},
					}
				)
					.then(parseJSON)
					.then(({ result, status }) => {
						if (result.error) {
							this.setState({ error: result.error });
						}
						this.get();
					});
			}
		);
	};

	render() {
		let params = this.state.params;

		return (
			<>
				<div className='panel-header'>
					<h5 className='component-header'>
						{'Health flags'.translate(this.props.lang)}
					</h5>
					<button
						className='btn add-button'
						onClick={() => {
							this.setState({
								form: true,
							});
						}}
					>
						<Isvg src={addIcon} /> {'Add'.translate(this.props.lang)}
					</button>
				</div>

				<ListBuilder
					lang={this.props.lang}
					loading={this.state.loading}
					total={this.state.total}
					hideEntries={false}
					showNumeration={false}
					hideFilters={true}
					fields={[
						{
							type: 'text',
							name: 'record',
							label: 'Recorded info'.translate(this.props.lang),

						},
						{
							type: 'text',
							name: 'substance',
							label: 'Substance'.translate(this.props.lang),
							// allowSort: true,
						},
						{
							type: 'text',
							name: 'types',
							label: 'Condition'.translate(this.props.lang),
							// allowSort: true,
						},
						{
							type: 'text',
							name: 'severityStatus',
							label: 'Severity'.translate(this.props.lang),
							// allowSort: true,
						},
						{
							type: 'text',
							name: 'reaction',
							label: 'Reaction'.translate(this.props.lang),
						},


					]}
					items={this.state.healthFlags.map((item) => {
						return {
							...item,
							___className: item?.isDeleted ? 'journal-tab-item-delete' : '',
							types: item?.type?.translate(this.props.lang),
							severityStatus: (
								<div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
									{item.severity === 'life-threatening' && (
										<>
											<Isvg width={20} height={20} src={AlertIcon} className='journal-healt-flags-info-icon' />
											<span style={{ color: 'red' }}>{item.severity.translate(this.props.lang)}</span>
										</>
									)}

									{item.severity === 'severe' && (
										<>
											<span style={{ color: 'red' }}>{item.severity.translate(this.props.lang)}</span>
										</>
									)}

									{item.severity === 'moderate' && (
										<>
											<span style={{ color: '#fbc02d' }}>{item.severity.translate(this.props.lang)}</span>
										</>
									)}
								</div>
							),
							record: (
								<div>
									{item.recordedBy && <div>{item.recordedBy}</div>}
									{item.recordedAt && <div>{item.recordedAt}</div>}
									{item.recordedDate && <div>{item.recordedDate}</div>}
								</div>
							),
						};
					})}

					actions={this.props.isConsentGrantedAndActive && this.state.isConsentActive ? [] : [

						{
							renderComponent: (item) =>
								item?.isDeleted ? (
									<div className="deleted-badge">
										{'Deleted'.translate(this.props.lang)}
									</div>
								) : null,
							onClick: (item) => { },
						},
						// {
						// 	component: (
						// 		<div className='tabel-action-tooltip'>
						// 			{' '}
						// 			<Isvg src={infoIcon} className='journal-info-icon' />
						// 			<div className='chat-icons-tooltip'>
						// 				{'Notes'.translate(this.props.lang)}
						// 			</div>{' '}
						// 		</div>
						// 	),
						// 	onClick: (item) => {
						// 		this.setState({ preview: item });
						// 	},
						// },
						{
							component: (
								<div className='tabel-action-tooltip'>
									{' '}
									<Isvg src={editIcon} />{' '}
									<div className='chat-icons-tooltip'>
										{'Edit'.translate(this.props.lang)}
									</div>{' '}
								</div>
							),
							onClick: (item) => {
								this.setState({ form: item });
							},
							condition: (item) => {
								const hasPermission = this.state.clinicUserPermissions?.write?.patient_health_flags;
								return hasPermission && item && !item.isDeleted;
							}
						},
						{
							component: (
								<div className='tabel-action-tooltip'>
									{' '}
									<Isvg src={deleteIcon} />{' '}
									<div className='chat-icons-tooltip'>
										{'Delete'.translate(this.props.lang)}
									</div>{' '}
								</div>
							),
							onClick: (item) => {
								this.setState({ deleteHealthFlag: item });
							},
							condition: (item) => {
								const hasPermission = this.state.clinicUserPermissions?.write?.patient_health_flags;
								return hasPermission && item && !item.isDeleted;
							}
						},
					]}
					rawItems={this.state.items}
					params={params}
					sortField={params.sortField}
					sortType={params.sortType}
					updateSort={this.updateSort}
					updateParams={this.updateParams}
					updateMultipleParams={this.updateMultipleParams}
				></ListBuilder>

				{/* Preview */}
				<PreviewModal
					lang={this.props.lang}
					isOpen={this.state.preview}
					toggle={() => this.setState({ preview: false })}
					title={'Notes'.translate(this.props.lang)}
				>
					{this.state.preview?.notes || "-"}
				</PreviewModal>

				{/* Delete */}
				<DeleteModal
					lang={this.props.lang}
					isOpen={this.state.deleteHealthFlag}
					toggle={() => this.setState({ deleteHealthFlag: null })}
					handler={() => {
						this.delete(this.state.deleteHealthFlag);
						this.state.deleteHealthFlag = null;
					}}
				>
					{'Delete this health flag'.translate(this.props.lang)}?
				</DeleteModal>

				{/* Error */}
				<ErrorModal
					lang={this.props.lang}
					isOpen={this.state.error}
					toggle={() => this.setState({ error: null })}
				>
					{this.state.error}
				</ErrorModal>

				{/*  Insert / Update */}
				{this.state.form ? (
					<FormBuilder
						selectedGroup={this.props.selectedGroup}
						selectedClinic={this.props.selectedClinic}
						lang={this.props.lang}
						onSubmit={(data) => {
							this.insertOrUpdate(data);
						}}
						initialValues={this.state.form}
						size='xl'
						isOpen={this.state.form}
						toggle={() =>
							this.setState({ form: null, doctorPermissions: false })
						}
						title={
							this.state.form._id
								? 'Edit health flag'.translate(this.props.lang)
								: 'Add new health flag'.translate(this.props.lang)
						}
						buttonText={'Save'
							.translate(this.props.lang)}
						disabledCreatedInfo={true}
						fields={[
							{
								type: 'row',
								children: [
									{
										type: 'col',
										width: {
											lg: 12,
											sm: 12,
											xs: 12,
										},
										children: [
											{
												type: 'row',
												children: [
													{
														type: 'col',
														width: {
															lg: 4,
															sm: 12,
															xs: 12,
														},
														children: [
															{
																type: 'combo-box',
																name: 'substance',
																label: 'Substance'.translate(this.props.lang),
																validate: required('Substance is required!'.translate(this.props.lang)),
																placeholder: 'e.g Peanuts'.translate(this.props.lang),
																options: [],
																optionsFetch: {
																	url: API_ENDPOINT + "/users/users/patient/patientHealthFlags/substances",
																	transformer: (items) => items.map(item => ({ label: item.name, value: item.name }))
																}
															}
														]
													},
													{
														type: 'col',
														width: {
															lg: 4,
															sm: 12,
															xs: 12,
														},
														children: [
															{
																type: 'select',
																name: 'type',
																label: 'Type'.translate(this.props.lang),
																values: [
																	{
																		name: 'Select'.translate(this.props.lang),
																		value: -1,
																	},
																	...this.state.TYPES_OPTIONS.map((item) => {
																		return {
																			name: item.label,
																			value: item.value,
																		};
																	}),
																],
																validate: [
																	required(
																		'Type is required!'.translate(
																			this.props.lang
																		)
																	),
																],
															},
														],
													},
													{
														type: 'col',
														width: {
															lg: 4,
															sm: 12,
															xs: 12,
														},
														children: [
															{
																type: 'select',
																name: 'severity',
																label: 'Severity'.translate(this.props.lang),
																values: [
																	{
																		name: 'Select'.translate(this.props.lang),
																		value: -1,
																	},
																	...this.state.SEVERITY_OPTIONS.map((item) => {
																		return {
																			name: item.label,
																			value: item.value,
																		};
																	}),
																],
																validate: [
																	required(
																		'Severity is required!'.translate(
																			this.props.lang
																		)
																	),
																],
															},
														],
													},
												],
											},
											{
												type: 'row',
												children: [
													{
														type: 'col',
														width: {
															lg: 12,
															sm: 12,
															xs: 12,
														},
														children: [
															{
																type: 'textarea',
																height: 100,
																name: 'reaction',
																label: 'Reaction'.translate(this.props.lang),
																placeholder: 'e.g Anaphylactic shock'.translate(this.props.lang),
															},
														],
													},
												],
											},
											{
												type: 'row',
												children: [
													{
														type: 'col',
														width: {
															lg: 12,
															sm: 12,
															xs: 12,
														},
														children: [
															{
																type: 'textarea',
																height: 100,
																name: 'notes',
																label: 'Notes'.translate(this.props.lang),
															},
														],
													},
												],
											},
										],
									},
								],
							},
						]}
					></FormBuilder>
				) : null}
			</>
		);
	}
}
